var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,{tag:"component",class:['link-container', { selected: _vm.selected }],attrs:{"href":_vm.href},on:{"!click":function($event){$event.preventDefault();return _setup.emit('click')}}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }